import { f0FormField } from '@factorialco/f0-react'
import { z } from 'zod'

import i18n from 'modules/core/lib/i18n'

export function buildBasicInfoSchema(competencyOptions: Array<{ value: string; label: string }>) {
  return z.object({
    trainingName: f0FormField(z.string().min(1), {
      label: i18n.t('trainings.training_requests.create.training_name'),
      placeholder: i18n.t(
        'trainings.training_requests.create.basic_info_placeholders.training_name'
      ),
    }),
    providerName: f0FormField(z.string().optional(), {
      label: i18n.t('trainings.training_requests.create.provider_name'),
      placeholder: i18n.t(
        'trainings.training_requests.create.basic_info_placeholders.provider_name'
      ),
    }),
    externalReference: f0FormField(z.string().optional(), {
      label: i18n.t('trainings.training_requests.create.external_reference'),
      placeholder: i18n.t(
        'trainings.training_requests.create.basic_info_placeholders.external_link'
      ),
    }),
    competencyIds: f0FormField(z.array(z.string()).optional(), {
      label: i18n.t('trainings.training_requests.create.competencies_label'),
      placeholder: i18n.t('trainings.training_requests.create.select_placeholder'),
      fieldType: 'select',
      multiple: true,
      showSearchBox: true,
      options: competencyOptions,
      renderIf: () => competencyOptions.length > 0,
    }),
  })
}

export const basicInfoSection = () => ({
  title: i18n.t('trainings.training_requests.create.basic_info_step'),
  description: i18n.t('trainings.training_requests.create.basic_info_description'),
})

const emptyStringArray: string[] = []

export const basicInfoDefaults = {
  competencyIds: emptyStringArray,
}
